import {
  createSummaryCardsConfig,
  createDataGridConfig,
} from '../email-pulse-config-defaults';
import { EMAIL_PULSE_DEFINITIONS } from '../email-pulse-definitions/email-pulse-definitions';

/**
 * Configuration for Offers tab summary cards
 */
export const offersSummaryCardsConfig = createSummaryCardsConfig(
  'marketingSummary',
  'OffersSummaryCards',
);

/**
 * Configuration for Offers tab data grid
 */
const offersGrid = createDataGridConfig(
  'offerTitle',
  EMAIL_PULSE_DEFINITIONS.offerTitle,
);
export const getOffersDataGridColumns = offersGrid.getColumns;
export const offersColumnVisibilityModel = offersGrid.columnVisibilityModel;
